export const UI_BASE = 'global_ui/UI_BASE';
export const UI_LOADING_SPINNER_SET = 'global_ui/UI_LOADING_SPINNER_SET';
